import Vue from 'vue';

const defaultState = {};

const mutations = {
    // Sites in the URL
    setSiteState(state, site) {
        Object.assign(state, site);
    },
    setUnits(state, units) {
        Vue.set(state, 'units', units);
    },
    setTreatmentUnits(state, treatmentUnits) {
        Vue.set(state, 'treatmentUnits', treatmentUnits);
    },
    resetSiteState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getSiteInfo({ commit, dispatch }, siteId) {
        try {
            const { data } = await this.$rq.getSiteInfo(siteId);
            await commit('setSiteState', data);
        } catch (err) {
            dispatch('resetSiteInfo');
        }
    },
    async getUnits({ commit, dispatch }, content) {
        try {
            const { data } = await this.$rq.getUnits(content.siteId, content.lang);
            if (Object.keys(data).length) await commit('setUnits', data);
        } catch (err) {
            dispatch('resetSiteInfo');
        }
    },
    async getTreatmentUnits({ commit, dispatch }, content) {
        try {
            const { data } = await this.$rq.getTreatmentUnits(content.lang);
            if (Object.keys(data).length) await commit('setTreatmentUnits', data);
        } catch (err) {
            dispatch('resetSiteInfo');
        }
    },
    resetSiteInfo({ commit }) {
        commit('resetSiteState');
    },
};

const getters = {
    site: state => state,
    units: ({ units }) => units,
    treatmentProgramUnits: ({ treatmentUnits }) => treatmentUnits,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
